var activation = {
	unserializeUrl: function(string) {
		var object = {};
		string = (string || window.location.href).replace(/(.*)\?/, '').split('&');
		for (var i in string) {
			if (string.hasOwnProperty(i)) {
				i = string[i].split('=');
				object[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
			}
		}
		return object;
	},
	serializeUrl: function(object) {
		var string = '';
		for (var i in object) {
			if (object.hasOwnProperty(i)) {
				if (string !== '') {
					string += '&';
				}
				string += i + '=' + object[i];
			}
		}
		return string;
	},
	getCookie: function(key) {
		var regExp = new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$');
		return decodeURIComponent(document.cookie.replace(regExp, '$1')) || undefined;
	},
	options: {
		type: 'ActivationByAc',
		message: 'Failed',
		products: {
			0: 'fa',
			1: 'pa',
			2: 'is',
			3: 'pr'
		}
	},
	getClientInfo: function(paramName, cookieName){
		var client = (window.avastGlobals && window.avastGlobals.client) ? window.avastGlobals.client : null,
			value;

			if(client){
				value = (client[paramName] === 'null') ? undefined : client[paramName];
			} else {
				value = this.getCookie(cookieName);
			}

			return value;
	}
};

(function($) {

	var url = activation.unserializeUrl(),
		proCookie = activation.getClientInfo('p_pro', 'x-avast-pro-i') || activation.getClientInfo('p_pro', 'x-avast-pro'),
		vbdCookie = activation.getClientInfo('p_vbd', 'x-avast-vbd-i') || activation.getClientInfo('p_vbd', 'x-avast-vbd'),
		params = {},
		$activationCode = $('#js-activation-code'),
		$activationLabel = $('#js-activation-label'),
		selectProduct = function(product) {
			if (product > 0) {
				$('.js-paid-product').show();
			} else if (product === 0) {
				$('.js-free-product').show();
			} else {
				$('.js-no-product').show();
			}
		};

	/* Get product from URL or cookies */
	if (typeof url.product !== 'undefined') {
		selectProduct(parseInt(url.product, 10));
	} else if (typeof url.p_pro !== 'undefined') {
		selectProduct(parseInt(url.p_pro, 10));
	} else if (typeof proCookie !== 'undefined') {
		selectProduct(parseInt(proCookie, 10));
	} else {
		$('.js-no-product').show();

		if (typeof avastGlobals.client !== 'undefined' && typeof avastGlobals.client.p_pro !== 'undefined') {
			selectProduct(parseInt(info.p_pro, 10));
			$('.js-no-product').hide();
		}
	}

	/* Show or hide activation code */
	if (!url.ac) {
		$activationCode.hide();
		$activationLabel.hide();
	}

	/* Activation code focus */
	$activationCode.on('focus.activation', function() {
		var $this = $(this);

		$this.select().on('mouseup.activation', function(e) {
			e.preventDefault();
			$this.off('mouseup.activation');
		});

	});

	/* Monitoring */
	if (typeof url.p_pro !== 'undefined') {

		/* Add monitoring type */
		params.type = activation.options.type;

		/* Add monitoring message */
		params.message = activation.options.message;

		/* Get p_lid from URL or cookies */
		if (url.p_lid) {
			params.p_lid = url.p_lid;
		} else if (avast.locale) {
			params.p_lid = avast.locale;
		}

		/* Get p_pro from URL or cookies */
		if (url.p_pro) {
			params.p_pro = activation.options.products[url.p_pro];
		} else if (proCookie) {
			params.p_pro = activation.options.products[proCookie];
		}

		/* Get p_vbd from URL or cookies */
		if (url.p_vbd) {
			params.p_vbd = url.p_vbd;
		} else if (vbdCookie) {
			params.p_vbd = vbdCookie;
		}

		/* Insert tracking image */
		$('body').append('<img class="av_hide" src="https://program.avast.com/ipm-ac-track.php?' + activation.serializeUrl(params) + '" />');

	}

})(jQuery);
